import React, { useState } from 'react';
import { useAdminAuth } from '../../hooks/useAdminAuth';

function AdminLogin({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, statusDetails } = useAdminAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      if (onLoginSuccess) {
        onLoginSuccess();
      }
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div className="card" style={{
        width: '100%',
        maxWidth: '500px',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
        borderRadius: '20px',
        border: 'none',
        overflow: 'hidden'
      }}>
        <div className="card-body p-4 p-md-5">
          <div className="text-center mb-4">
            <div 
              className="auth-logo-container"
              style={{
                width: '200px',
                height: '80px',
                margin: '0 auto 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              <img 
                src="/logos/logo.png" 
                alt="Circana Logo" 
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain'
                }}
                onError={(e) => {
                  // Fallback to icon if logo not found
                  e.target.style.display = 'none';
                  const icon = document.createElement('i');
                  icon.className = 'bi bi-shield-lock';
                  icon.style.fontSize = '3rem';
                  icon.style.color = '#667eea';
                  e.target.parentElement.appendChild(icon);
                }}
              />
            </div>
            <h2 className="mb-2" style={{ fontWeight: 700, color: '#333' }}>Admin Login</h2>
            <p className="text-muted mb-0">Enter your credentials to access the admin panel</p>
          </div>

          {error && (
            <div className="alert alert-danger d-flex align-items-start" role="alert">
              <i className="bi bi-exclamation-triangle me-2 mt-1"></i>
              <div>{error}</div>
            </div>
          )}

          {statusDetails?.requiresUidFix && (
            <div className="alert alert-warning" role="alert">
              <h6 className="alert-heading">
                <i className="bi bi-info-circle me-2" />
                Fix your admin record
              </h6>
              <p className="mb-2">
                {statusDetails.message || 'Your admin document exists under a different ID, so Firestore blocks access.'}
              </p>
              <ol className="mb-0 ps-3">
                <li>Log in to the normal site and run <code>firebase.auth().currentUser.uid</code> in the browser console.</li>
                <li>In Firebase → Firestore → <code>adminUsers</code>, delete the old record and create a new one using that UID as the document ID (see <code>DEBUG_ADMIN.md</code> Step 2A).</li>
                <li>Click Publish on Firestore rules, then refresh this page.</li>
              </ol>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label fw-semibold">Email Address</label>
              <input
                type="email"
                className="form-control form-control-lg"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                required
                disabled={loading}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label fw-semibold">Password</label>
              <input
                type="password"
                className="form-control form-control-lg"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg w-100"
              disabled={loading}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                padding: '12px',
                fontWeight: 600
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Logging in...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right me-2"></i>
                  Login
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;

